export default __webpack_public_path__ + "images/786f6d5a98f50b34c7e3abad9eac87da-pointer.svg";